import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import Image from 'next/image';
import dynamic from 'next/dynamic';
import { MIN_MOBILE_WIDTH, getImageSrc, getImageUrlWithSize } from '@common/Utility/common-utils';
import useIntersectionObserver from '@common/Hooks/useIntersectionObserver';
import { PAGE_TITLES } from '@common/Utility/constants';
import { useNavigationURL } from '@common/Utility/generateNavigationURL';

const BannerSliderItem = ({ item, objectCategoryItems, onView, pageName, sectionName, onBannerClick, onVisibilityChange }) => {
  const TimerBanner = dynamic(() => import('@common/Component/TimerBanner/TimerBanner'), {
    ssr: false,
  });

  const generateUrl = useNavigationURL();
  const [windowWidth, setWindowWidth] = useState();

  const handleTimerVisibilityChange = useCallback((isVisible) => {
    if (isVisible === false && objectCategoryItems?.showTimer) {
      onVisibilityChange(item?.order, false);
    }
  }, [objectCategoryItems]);

  useEffect(() => {
    setWindowWidth(window.innerWidth);
  }, []);

  const { inViewRef } = useIntersectionObserver(() => onView(item), {
    threshold: 0.5,
  });

  return (
    <a
      className="box"
      ref={inViewRef}
      href={generateUrl(item?.linkWeb)}
      onClick={(e) => {
        e.preventDefault();
        if (sectionName === 'plp banner' || sectionName === 'dynamic') {
          item?.linkWeb && item?.linkWeb.trim() !== '' && onBannerClick(item);
        } else {
          onBannerClick(item);
        }
      }}
    >
      {pageName === 'clinic' ? (
        <Image src={getImageSrc(item?.file)} alt={pageName ?? PAGE_TITLES?.ASTER_HOME} />
      ) : (
        <>
          <Image
            src={windowWidth <= MIN_MOBILE_WIDTH ? getImageUrlWithSize(item?.imageMobile, windowWidth) : 
              getImageUrlWithSize(item?.imageWeb, windowWidth)}
            alt={pageName ?? PAGE_TITLES?.ASTER_HOME}
            layout="fill"
            style={{ objectFit: 'contain' }}
            priority
            unoptimized
          />
          {objectCategoryItems?.showTimer && (
            <div className="imageTimerContainer">
              <p className='imageTimerStyle'>
                <TimerBanner
                  onVisibilityChange={handleTimerVisibilityChange}
                  timerTheme={objectCategoryItems?.timerTheme}
                  offerStartTime={objectCategoryItems?.launchDateTime}
                  offerEndTime={objectCategoryItems?.endLaunchDateTime}
                />
              </p>
            </div>
          )}
        </>
      )}
    </a>
  );
};

BannerSliderItem.propTypes = {
  item: PropTypes.object.isRequired,
  onView: PropTypes.func.isRequired,
  pageName: PropTypes.string.isRequired,
  sectionName: PropTypes.string.isRequired,
  onBannerClick: PropTypes.func.isRequired,
  objectCategoryItems: PropTypes.object.isRequired,
};

export default BannerSliderItem;
